import React from 'react';
import { useTranslation } from 'react-i18next';
import { Calendar } from 'lucide-react';
import { Button } from '../../../../components/ui/button';
import { Dialog, DialogContent } from '../../../../components/ui/dialog';
import useLimits from '../../../plan/hooks/limits';
import { initZoomMeetings } from '../../../../services/integrationService';

interface ConnectZoomMeetingsModalProps {
  onClose: () => void;
}

const ConnectZoomMeetingsModal = ({
  onClose,
}: ConnectZoomMeetingsModalProps) => {
  const { t } = useTranslation();
  const guardLimits = useLimits();

  const handleConnectZoomMeetings = async () => {
    guardLimits('meetingBot', async () => {
      const response = await initZoomMeetings();
      window.location.href = response.oauthUrl;
    });
  };

  return (
    <Dialog open onOpenChange={(open) => !open && onClose()}>
      <DialogContent className="max-w-md">
        <div className="flex flex-col items-center space-y-4 py-8">
          <Calendar className="w-12 h-12 text-primary" />
          <h3 className="text-lg font-semibold">
            {t('settings.meetingBot.zoom.connect')}
          </h3>
          <p className="text-sm text-muted-foreground text-center">
            {t('settings.meetingBot.zoom.allowAccess')}
          </p>
          <Button
            onClick={handleConnectZoomMeetings}
            data-testid="connect-zoom-meetings-button"
          >
            <Calendar className="w-4 h-4 mr-2" />
            {t('settings.meetingBot.zoom.connectButton')}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ConnectZoomMeetingsModal;
